module.exports = __webpack_public_path__ + "img/63_6.d360d305.png";